export default __webpack_public_path__ + "static/media/login-background-min.9aeeaee2.png";